import { InlineSvg } from 'components/svg';
import { useDebounce } from 'hooks/use-debounce';
import { useEffect, useState } from 'react';

interface SearchInputProps {
  value?: string;
  placeholder?: string;
  onSearchChange?: (value: string | undefined) => void;
  debounceMs?: number;
}

export const SearchInput = ({
  value,
  placeholder = 'Search...',
  onSearchChange,
  debounceMs = 300
}: SearchInputProps) => {
  const [isFirstCall, setFirstCall] = useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState<string>(value ?? '');
  const debouncedSearchTerm = useDebounce(searchTerm, debounceMs);

  useEffect(
    () => {
      if (isFirstCall && debouncedSearchTerm !== undefined && searchTerm !== undefined) {
        onSearchChange?.(debouncedSearchTerm || undefined);
      }

      setFirstCall(true);
    },
    [debouncedSearchTerm] // Only call effect if debounced search term changes
    // More details about useDebounce: https://usehooks.com/useDebounce/
  );

  return (
    <div className="d-flex align-items-center position-relative">
      <InlineSvg path="/media/icons/duotune/general/gen021.svg" className="svg-icon-1 position-absolute ms-6" />
      <input
        name="search"
        type="text"
        data-kt-employee-table-filter="search"
        className="form-control form-control-solid ps-14"
        placeholder={placeholder}
        // onChange={handleChange}
        // onBlur={handleChange}
        // value={value ?? ''}
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
    </div>
  );
};
